export default __webpack_public_path__ + "static/media/wieldy.4337dff1.less";